var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxStorage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3992_548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8413 8.77183C18.066 9.09163 18.0211 9.50282 17.7514 9.73124C17.4368 9.95969 16.9875 9.91397 16.7627 9.63988L15.1898 7.58397L13.6619 9.59417C13.4371 9.91397 12.9877 9.91397 12.6732 9.68556C12.3586 9.45711 12.3137 9.04596 12.5383 8.72615L14.3359 6.35044L12.5383 3.97473C12.3137 3.65492 12.4035 3.19809 12.6732 2.96964C12.9877 2.74119 13.4371 2.83258 13.6619 3.10671L15.1898 5.16258L16.7627 3.19806C16.9874 2.87826 17.3919 2.83258 17.7514 3.06099C18.066 3.28945 18.066 3.74631 17.8413 4.06611L16.0886 6.39612L17.8413 8.77183ZM9.66217 8.4977C8.49372 8.4977 7.54998 7.58397 7.54998 6.39612C7.54998 5.25397 8.49372 4.29453 9.66217 4.29453C10.8306 4.29453 11.7744 5.25397 11.7744 6.39612C11.7294 7.58397 10.7857 8.4977 9.66217 8.4977ZM3.46039 8.4977C2.29194 8.4977 1.34821 7.58397 1.34821 6.39612C1.34821 5.25397 2.29194 4.29453 3.46039 4.29453C4.62885 4.29453 5.57258 5.25397 5.57258 6.39612C5.57258 7.58397 4.62885 8.4977 3.46039 8.4977ZM9.66217 2.92393C8.35893 2.92393 7.19044 3.65492 6.60621 4.75139C6.02199 3.65492 4.85357 2.92393 3.50536 2.92393C2.69641 2.92393 1.97736 3.19806 1.39317 3.60925V0.685316C1.39314 0.319802 1.07852 0 0.719016 0C0.314578 0 0 0.319802 0 0.685316V6.44179C0.0449297 8.3606 1.57289 9.86826 3.46043 9.86826C4.8086 9.86826 5.97706 9.09163 6.56128 7.99513C7.14551 9.09163 8.31396 9.86826 9.61724 9.86826C11.5497 9.86826 13.1226 8.31493 13.1226 6.35037C13.1675 4.47723 11.5946 2.9239 9.66213 2.9239",
    fill: "#0061D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3992_548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 9.9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxStorage);
export default __webpack_public_path__ + "static/media/box-storage.d1cf4dba0d3895768c663f89d17eacb7.svg";
export { ForwardRef as ReactComponent };